import { Panel } from '../ui/Panel';

export function AnalysisNarrative({ items }: { items: string[] }): React.JSX.Element {
  return (
    <Panel title="Human-readable chart study" description="Each statement is contextual evidence; none is a standalone trade command.">
      <div className="narrative-list">
        {items.map((item, index) => <div className="narrative-item" key={`${index}-${item.slice(0, 20)}`}>{item}</div>)}
      </div>
    </Panel>
  );
}
